import { ResolutionTypes, ServiceTypes } from 'config/global-enums';

import { BASIC_URL } from 'config/api-variables';
import { Modal } from 'antd';
import dayjs from 'dayjs';

export const getUrlForImage = (
  url,
  resolution = ResolutionTypes.SIXFOUR,
  serviceType = ServiceTypes.POST,
  URL_VALUE = BASIC_URL,
) => {
  let imageName = '';

  if (url) {
    const s = url.split('/');
    imageName = s[s.length - 1];
  }
  return (
    URL_VALUE +
    '/file/media/read?' +
    `name=${imageName}` +
    `&resolution=${resolution}` +
    `&service_type=${serviceType}`
  );
};

export const convertDataToHtml = (data, QuillDeltaToHtmlConverter) => {
  let html;
  if (data) {
    try {
      const PARSE_DATA = JSON.parse(data);
      const converter = new QuillDeltaToHtmlConverter(PARSE_DATA, {});
      html = converter.convert();
    } catch (error) {
      html = data;
    }
  }
  return html;
};

export const getActionStatusWithType = (data, actionType) => {
  let action;
  if (data) {
    if (data.length > 0) {
      action = data.find(item => item.type === actionType);
      return action.value;
    }
    return false;
  }
  return false;
};

export const getDesignation = item => {
  return (
    (item.designation && item.department
      ? `${item.designation}, ${item.department}`
      : item.designation || item.department) || '-'
  );
};

export const getBase64 = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
};

export const generateImageFile = (
  imageUrl,
  uid,
  serviceType = ServiceTypes.POST,
) => ({
  uid,
  name: imageUrl?.split('/').pop(),
  status: 'done',
  url: getUrlForImage(imageUrl, ResolutionTypes.SIXFOUR, serviceType),
});

export const capitalizeFirst = value =>
  value.trim().length > 1
    ? value.charAt(0).toUpperCase() + value.slice(1)
    : value;

export const capitalizeFirstLetter = word => {
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
};

export const capitalizeWords = sentence => {
  if (sentence == null) return null; // This checks for both null and undefined
  if (sentence == null) return null; // This checks for both null and undefined
  return sentence.replace(/\b\w+\b/g, match => {
    return capitalizeFirstLetter(match);
  });
};

export const capitalizeFirstCharacter = sentence => {
  if (sentence === null) return null;
  return sentence.replace(/\b\w+\b/g, match => {
    return capitalizeFirst(match);
  });
};

// export const warningModal = ({
//   text,
//   onOk = () => {},
//   okText = 'OK',
//   cancelText = 'Cancel',
//   okType = 'danger',
// }) => {
//   return Modal.warning({
//     title: text,
//     onOk,
//     okText,
//     cancelText,
//     okType,
//     closable: true,
//     maskClosable: true,
//   });
// };

export const warningModal = ({
  text,
  onOk = () => {},
  onCancel = () => {},
  okText = 'Yes',
  cancelText = 'No',
  okType = 'danger',
}) => {
  return Modal.confirm({
    title: text,
    onOk,
    onCancel,
    okText,
    cancelText,
    okType,
    closable: true,
    maskClosable: true,
    autoFocusButton: 'cancel',
  });
};

// export const warningModal = ({
//   text,
//   onOk = () => {},
//   onCancel = () => {},
//   okText = 'Yes',
//   cancelText = 'No',
// }) => {
//   return Modal.confirm({
//     title: text,
//     onOk,
//     onCancel,
//     okText,
//     cancelText,
//     closable: true,
//     maskClosable: true,
//     // Custom button props
//     okButtonProps: {
//       type: 'danger',
//       style: {
//         // Remove hover effect by making it the same as normal state
//         backgroundColor: '#ff4d4f',
//         // borderColor: '#ff4d4f',
//       },
//     },
//     cancelButtonProps: {
//       type: 'default',
//       style: { color: '#1890ff' },
//     },
//     autoFocusButton: 'cancel',
//   });
// };

export const extractTextFromHTML = htmlString => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  return doc.body.textContent || '';
};

export const generateColorFromNumber = number => {
  const r = (number & 0xff0000) >> 16;
  const g = (number & 0x00ff00) >> 8;
  const b = number & 0x0000ff;

  return `rgb(${r}, ${g}, ${b})`;
};

export const generateRandomColor = () => {
  const randomColor = `rgb(${Math.floor(Math.random() * 256)}, ${Math.floor(
    Math.random() * 256,
  )}, ${Math.floor(Math.random() * 256)})`;
  return randomColor;
};

export const openLocation = (address, lat, long, location) => {
  if (lat && long) {
    const locationUrl = `http://maps.google.com/?q=${lat},${long}`;
    window.open(locationUrl, '_blank');
  } else if (address) {
    const locationUrl = `http://maps.google.com/?q=${address}`;
    window.open(locationUrl, '_blank');
  } else {
    const locationUrl = `http://maps.google.com/?q=${location}`;
    window.open(locationUrl, '_blank');
  }
};

export const darkenColor = (color, factor) => {
  // Convert hex to RGB
  let r = parseInt(color.slice(1, 3), 16);
  let g = parseInt(color.slice(3, 5), 16);
  let b = parseInt(color.slice(5, 7), 16);

  // Darken the color
  r = Math.floor(r * (1 - factor));
  g = Math.floor(g * (1 - factor));
  b = Math.floor(b * (1 - factor));

  // Convert back to hex
  const darkenedColor = `#${((r << 16) | (g << 8) | b)
    .toString(16)
    .padStart(6, '0')}`;

  return darkenedColor;
};

export const NumberFormatter = value => {
  let finalValue = new Intl.NumberFormat('en-US', {
    notation: 'compact',
    maximumFractionDigits: 0,
  }).format(value);

  return finalValue;
};

export const formatDenomination = (
  value,
  currency = '',
  isIndianDenomination = false,
  decimals = 2,
) => {
  const formatList =
    currency === 'INR' || isIndianDenomination
      ? [
          { num: 1e7, den: 'Cr' },
          { num: 1e5, den: 'L' },
          { num: 1e3, den: 'T' },
        ]
      : [
          { num: 1e12, den: 'Tr' },
          { num: 1e9, den: 'B' },
          { num: 1e6, den: 'M' },
          { num: 1e3, den: 'K' },
        ];
  let finalValue = Math.floor(value).toFixed(decimals);
  formatList.forEach(el => {
    if (finalValue >= el.num) {
      finalValue = (finalValue / el.num).toFixed(2) + el.den;
      return;
    }
  });

  return (currency ? currency + ' ' : '') + finalValue;
};

export function getDurationFromMins(mins, needsComplete) {
  var d = (mins / 1440) | 0;
  var h = (mins / 60 - d * 24) | 0,
    m = mins % 60 | 0;

  return needsComplete
    ? (d > 0 ? `${d}d ` : '') + (h > 0 ? `${h}h ` : '') + (m > 0 ? `${m}m` : '')
    : mins >= 60
    ? d > 0
      ? h > 0
        ? `${d}d ${h}h`
        : `${d}d`
      : m > 0
      ? `${h}h ${m}m`
      : `${h}h`
    : `${m}m`;
}

export const targetVmin = {
  ...(window?.innerWidth > 1600
    ? {
        size1: '1.4vmin',
        size2: '1.6vmin',
        size3: '1.8vmin',
        size4: '2vmin',
        size5: '2.4vmin',
        size6: '3vmin',
        size7: '3.6vmin',
        size8: '4.4vmin',
        size9: '5.2vmin',
        size10: '5.6vmin',
        size11: '7vmin',
        size12: '12vmin',
        size13: '16vmin',
        size14: '30vmin',
        size15: '36vmin',
      }
    : {
        size1: '1vmin',
        size2: '1.2vmin',
        size3: '1.4vmin',
        size4: '1.6vmin',
        size5: '1.8vmin',
        size6: '2.4vmin',
        size7: '3.4vmin',
        size8: '3.6vmin',
        size9: '4vmin',
        size10: '4.6vmin',
        size11: '6.4vmin',
        size12: '10vmin',
        size13: '14vmin',
        size14: '24vmin',
        size15: '30vmin',
      }),
};

export const joinArrayWords = ({ items, name = 'name', objIsString = false }) =>
  items?.length > 0 ? (
    items
      .map(el => {
        return objIsString ? el : el[name];
      })
      .join(', ')
  ) : (
    <>-</>
  );

export const tableTextRender = (text, renderText) =>
  !text?.toString()?.trim() ? <>-</> : <>{renderText || text}</>;

export const findObjectRecursively = (currArr, selectedKey, keyName) => {
  var result;
  currArr.some(
    o =>
      (result =
        o[keyName || 'key'] === selectedKey
          ? o
          : findObjectRecursively(o.children || [], selectedKey)),
  );
  return result;
};

export const removeHttpHttpsWww = url => {
  url = url.replace(/^https?:\/\//, '');

  url = url.replace(/^www\./, '');

  return url;
};

export const extractDate = timeStamp => {
  const dateObject = new Date(timeStamp);

  const year = dateObject.getFullYear();
  const month = dateObject.getMonth() + 1; // Note: Months are zero-based
  const day = dateObject.getDate();

  const formattedDate = `${year}-${month < 10 ? '0' : ''}${month}-${
    day < 10 ? '0' : ''
  }${day}`;

  return formattedDate;
};

export const extractTime = timeStamp => {
  const dateObject = new Date(timeStamp);

  const hours = dateObject.getHours();
  const minutes = dateObject.getMinutes();

  const formattedTime = `${hours < 10 ? '0' : ''}${hours}:${
    minutes < 10 ? '0' : ''
  }${minutes}`;

  return formattedTime;
};

export const getContrastYIQ = hexColor => {
  const r = parseInt(hexColor.slice(1, 3), 16);
  const g = parseInt(hexColor.slice(3, 5), 16);
  const b = parseInt(hexColor.slice(5), 16);
  const yiq = (r * 269 + g * 567 + b * 114) / 1000;
  return yiq >= 128 ? 'rgba(0, 0, 0, 0.65)' : '#fff';
};

export const numberWithCommas = (x, locale = 'en-IN') => {
  // Handle null, undefined, NaN, and non-number values
  if (x === null || x === undefined) {
    return 0;
  }

  // Convert string to number if it's a string
  let num = x;
  let hasSign = false;
  let sign = '';

  if (typeof x === 'string') {
    // Check if number has a sign
    hasSign = x.startsWith('+') || x.startsWith('-');
    sign = x.startsWith('+') ? '+' : x.startsWith('-') ? '-' : '';
    // Remove + or - prefix if it exists
    num = hasSign ? x.substring(1) : x;
    num = parseFloat(num);
  } else if (typeof x === 'number') {
    hasSign = x < 0;
    sign = hasSign ? '-' : '';
    num = Math.abs(x);
  }

  if (isNaN(num)) {
    return 0;
  }

  // Format the number based on locale
  const formatter = new Intl.NumberFormat(locale, {
    minimumFractionDigits: num.toString().includes('.') ? 2 : 0,
    maximumFractionDigits: 20,
  });

  // Add the sign only if it was present in the input
  return hasSign ? sign + formatter.format(num) : formatter.format(num);
};

export const hexToRgb = hex => {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
};

export const getRandomSuggestionBgColor = () => {
  const colors = [
    { backgroundColor: '#000000', textColor: '#FFFFFF' },
    { backgroundColor: '#FFFFFF', textColor: '#000000' },
  ];
  const randomIndex = Math.floor(Math.random() * colors.length);
  return colors[randomIndex];
};

export const getStatusColor = text => {
  switch (text) {
    case 'active':
      return 'green';
    case 'inactive':
      return 'magenta';
    case 'pending approval':
      return 'orange';

    case 'paid':
      return 'green';
    case 'unpaid':
      return 'magenta';
    case 'cancelled':
      return 'red';

    case 'Processing' || 'pending':
      return 'blue';
    case 'Shipped':
      return 'cyan';
    case 'Delivered':
      return 'lime';
    case 'Returned':
      return 'orange';
    case 'Canceled' || 'cancelled':
      return 'red';
    case 'Completed':
      return 'green';

    case 'expired':
      return 'geekblue';
    case 'suspended':
      return 'purple';

    case 'pending':
      return 'orange';
    case 'approved':
      return 'green';
    case 'successful':
      return 'green';
    case 'rejected':
      return 'red';
    case 'failed':
      return 'red';

    case 'Available':
      return 'green';
    case 'Scanned':
      return 'red';
    case 'Pending':
      return 'orange';
    case 'Expired':
      return 'volcano';

    default:
      return null;
  }
};

export const validateUrl = (_, value) => {
  if (!value || /^(http:\/\/|https:\/\/)/.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject(
    new Error('The URL must start with http:// or https://'),
  );
};

export const capitalizeAndRenderText = (text, renderText) => {
  const capitalizedText = text ? capitalizeWords(text) : '';
  return !capitalizedText.trim() ? (
    <>-</>
  ) : (
    <>{renderText || capitalizedText}</>
  );
};

export const isHttpUrl = url => {
  return /^(http:\/\/|https:\/\/)/.test(url);
};

export const determineNameTitle = name_title => {
  switch (name_title) {
    case 1:
      return 'Mr. ';
    case 2:
      return 'Ms. ';
    case 3:
      return 'Mrs. ';
    case 4:
      return 'Dr. ';
    case 5:
      return 'Prof. ';
    default:
      return '';
  }
};

export const formatPriceWithCommas = number => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const getCountryName = ({ countriesList, countryCode }) => {
  const country = countriesList?.find(country => country.code === countryCode);

  return country?.name || countryCode;
};

export const getStateName = ({ statesList, stateCode }) => {
  const state = statesList?.find(state => state.code === stateCode);

  return state?.name || stateCode;
};

export const transparentize = (color, alpha) => {
  let r, g, b;

  // Handle hex codes
  if (color.startsWith('#')) {
    const hex = color.slice(1);

    // Handle shorthand hex (#f00)
    if (hex.length === 3) {
      r = parseInt(hex[0] + hex[0], 16);
      g = parseInt(hex[1] + hex[1], 16);
      b = parseInt(hex[2] + hex[2], 16);
    } else if (hex.length === 6) {
      r = parseInt(hex.slice(0, 2), 16);
      g = parseInt(hex.slice(2, 4), 16);
      b = parseInt(hex.slice(4, 6), 16);
    } else {
      throw new Error('Invalid hex color');
    }
  }

  // Optionally, you could extend this to support named colors or rgb(a)
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const downloadQRCode = (qrElementId, fileName = 'qrcode') => {
  const canvas = document.getElementById(qrElementId)?.querySelector('canvas');

  if (!canvas) {
    console.warn(`Canvas not found for element ID: ${qrElementId}`);
    return;
  }

  const pngUrl = canvas
    .toDataURL('image/png')
    .replace('image/png', 'image/octet-stream');
  const downloadLink = document.createElement('a');
  downloadLink.href = pngUrl;
  downloadLink.download = `${fileName}.png`;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
};

export const getIssueSourceIcon = issueSource => {
  let IconComponent = null;

  switch (issueSource?.toLowerCase()) {
    case 'facebook':
    case 'messenger':
      IconComponent = (
        <img
          height={16}
          src="/images/SupportImages/messenger.svg"
          alt="messenger"
        />
      );
      break;
    case 'whatsapp':
      IconComponent = (
        <img
          height={16}
          src="/images/SupportImages/whatsapp.svg"
          alt="WhatsApp"
        />
      );
      break;
    case 'instagram':
      IconComponent = (
        <img
          height={16}
          src="/images/SupportImages/instagram.svg"
          alt="Instagram"
        />
      );
      break;
    case 'cleandesk':
      IconComponent = (
        <img
          height={16}
          src="/images/SupportImages/cleandesk.svg"
          alt="CleanDesk"
        />
      );
      break;
    case 'voicemail':
      IconComponent = (
        <img
          height={16}
          src="/images/SupportImages/voicemail.svg"
          alt="voicemail"
        />
      );
      break;
    default:
      // Return null for unknown sources
      IconComponent = (
        <img
          height={16}
          src="/images/SupportImages/cleandesk.svg"
          alt="CleanDesk"
        />
      );
      break;
  }

  return IconComponent;
};

export const getHSStageAndStausColor = type => {
  switch (type) {
    // Stage 1: Applied
    case 'Applied':
    case 'Applied on behalf':
      return 'blue'; // Antd Blue

    // Stage 2: Screening
    case 'Screening Scheduled':
    case 'Screening In Progress':
      return 'orange'; // Antd Orange
    case 'Screening Completed':
      return 'green'; // Antd Green
    case 'Screening Cancelled':
      return 'red'; // Antd Red
    case 'Qualified':
      return 'gold'; // Antd Gold
    case 'Not Qualified':
      return 'volcano'; // Antd Volcano

    // Stage 3: Interview
    case 'Interview Scheduled':
    case 'Interview Rescheduled':
      return 'blue'; // Antd Blue
    case 'Interview Cancelled':
      return 'red'; // Antd Red
    case 'Interview Completed':
      return 'green'; // Antd Green
    case 'No-show (Candidate)':
    case 'No-show (Interviewer)':
      return 'volcano'; // Antd Volcano
    case 'Feedback Pending':
      return 'gold'; // Antd Gold
    case 'Feedback Submitted':
      return 'green'; // Antd Green

    // Stage 4: Assessment
    case 'Assessment Scheduled':
    case 'Assessment In Progress':
      return 'blue'; // Antd Blue
    case 'Assessment Completed':
      return 'green'; // Antd Green
    case 'Assessment Failed':
      return 'red'; // Antd Red
    case 'Assessment Passed':
      return 'gold'; // Antd Gold

    // Stage 5: Shortlisting
    case 'Shortlisted':
    case 'Shortlisted for Final Interview':
      return 'green'; // Antd Green
    case 'Under Review for Shortlisting':
      return 'gold'; // Antd Gold

    // Stage 6: Offer
    case 'Offer Made':
    case 'Offer Accepted':
      return 'green'; // Antd Green
    case 'Offer Declined':
      return 'red'; // Antd Red
    case 'Counteroffer Negotiation In Progress':
      return 'gold'; // Antd Gold

    // Stage 7: Hiring
    case 'Hired':
    case 'Joining Date Confirmed':
    case 'Onboarded':
      return 'green'; // Antd Green
    case 'Onboarding In Progress':
      return 'gold'; // Antd Gold

    // Stage 8: Rejected/Closed
    case 'Not Selected':
    case 'Application Withdrawn':
    case 'Offer Rejected':
    case 'Closed Due to Inactivity':
      return 'red'; // Antd Red

    // Stage 9: On Hold
    case 'On Hold (Internal)':
    case 'On Hold (Candidate Request)':
      return 'gold'; // Antd Gold

    // Default
    default:
      return 'default'; // Antd Default Gray
  }
};

export const getTypeOfTicketColor = typeOfTicket => {
  switch (typeOfTicket) {
    case 'C':
      return 'magenta';
    case 'Q':
      return 'geekblue';
    case 'R':
      return 'gold';
    case 'G':
      return 'cyan';
    case 'T':
      return 'purple';
    case 'HS':
      return 'orange';
    default:
      return null;
  }
};

export const getTypeOfTicket = typeOfTicket => {
  switch (typeOfTicket) {
    case 'C':
      return 'Complaint';
    case 'Q':
      return 'Query';
    case 'R':
      return 'Request';
    case 'G':
      return 'Query';
    // return 'Generic';
    case 'T':
      return 'Ticket';
    case 'HS':
      return 'Screened';
    default:
      return ' - ';
  }
};

export const formatDate = date => {
  const unixTime = dayjs(date).valueOf();
  return unixTime;
};
